import {validateValue} from '../helpers/validation'

// Begin action types
export const FETCH_USER_EDIT_DATA_SUCCESS = 'FETCH_USER_EDIT_DATA_SUCCESS'
export const VALIDATE_USER_EDIT_FIELD = 'VALIDATE_USER_EDIT_FIELD'
export const SUBMIT_USER_EDIT_FIELDS = 'SUBMIT_USER_EDIT_FIELDS'
export const CLEAR_USER_EDIT_FIELDS = 'CLEAR_USER_EDIT_FIELDS'
// End action types

export const fetchUserEditDataSuccess = (data) => ({
  type: FETCH_USER_EDIT_DATA_SUCCESS,
  data
});
export const validateUserEditField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_USER_EDIT_FIELD,
    field
  }
}
export const submitUserEditFields = (fields) => {
  return {
    type: SUBMIT_USER_EDIT_FIELDS,
    fields
  }
}
export const clearUserEditFields = () => { 
  return {
    type: CLEAR_USER_EDIT_FIELDS
  }
}
